import { CDN_BASE_URL } from './constants';
import PartnerButton from './PartnerButton';
const SupportArtists = () => <section className={'@container relative @[125rem]:mt-10 mt-[60px] @[125rem]:mb-10 mb-5 flex @4xl:h-[440px] @7xl:h-[387px] @[96rem]:h-[440px] @max-2xl:h-[520px] h-[736px] w-full @4xl:items-center overflow-hidden @4xl:bg-auto bg-[#c9cbc8] bg-cover bg-right-bottom'} data-sentry-component="SupportArtists" data-sentry-source-file="SupportArtists.tsx">
    {/* Wrapper for image + artist credit to keep them together */}
    <div className="absolute inset-0 @4xl:top-auto @4xl:right-0 @4xl:bottom-0 @4xl:left-auto">
      <picture className="relative @max-2xl:block h-full w-full" data-sentry-element="picture" data-sentry-source-file="SupportArtists.tsx">
        <img alt="Cloudchord playing an acoustic guitar in front of a grey wall" className="@max-2xl:absolute @max-2xl:-top-[205px] @max-2xl:-right-[212px] @4xl:h-[736px] @max-2xl:h-[783px] h-full @[125rem]:w-full @max-2xl:w-[1772px] w-full @max-2xl:max-w-none object-cover @[125rem]:object-[80%_bottom] @[96rem]:object-right object-[88%_bottom]" src={`${CDN_BASE_URL}/rae_support-artists.jpg`} />
      </picture>
      {/* Artist credit - positioned relative to the wrapper/image */}
      <div className="absolute @2xl:right-[55%] @4xl:right-[50%] @5xl:right-[45%] @6xl:right-[42%] @7xl:right-[40%] @[125rem]:right-[600px] @[96rem]:right-[36%] right-[67%] @2xl:bottom-[18%] @7xl:bottom-[14%] @[125rem]:bottom-[12%] bottom-[22%] z-10 @max-2xl:hidden text-right">
        <p className="font-semibold @4xl:text-base text-pink-500 text-sm">
          Cloudchord,
        </p>
        <p className="@4xl:text-base text-gray-700 text-sm">
          Emmy-winning lofi icon
        </p>
      </div>
    </div>
    <div className="special-page-container relative @max-2xl:flex @max-2xl:flex-col @4xl:pt-0 @max-2xl:pt-10 pt-[60px]">
      <h2 className="mb-5 text-balance text-left font-semibold text-2xl text-gray-950 tracking-tightest 2xl:text-3xl">
        Help support artists
      </h2>
      <div className="@max-2xl:flex @4xl:w-[568px] @max-2xl:flex-1 @max-2xl:flex-col">
        <p className="@max-2xl:mb-5 mb-6 text-pretty font-sans @4xl:text-base text-gray-950 text-sm">
          Artists and creators are at the heart of everything we do.{' '}
          <br className="@max-2xl:hidden" />
          <span className="font-semibold">
            We make sure our artists get paid fairly for their work, always.
          </span>
        </p>
        <p className="@4xl:mb-10 @max-2xl:mb-8 mb-5 text-pretty font-sans @4xl:text-base text-gray-950 text-sm">
          By sharing Uppbeat with your <br className="@2xl:hidden" />
          audience, you'll help strengthen <br />
          our community of creators <br className="@2xl:hidden" />
          and promote amazing artists!
        </p>
        <p className="@2xl:hidden font-sans text-pink-500 text-sm">
          <span className="font-semibold">Cloudchord</span>,
          <br />
          <span className="text-gray-700">Emmy-winning lofi icon</span>
        </p>
        <div className="@max-2xl:mt-auto @4xl:mb-[76px] @7xl:mb-5 @max-2xl:mb-10 mb-14">
          <PartnerButton className="w-full sm:w-auto" size="lg" data-sentry-element="PartnerButton" data-sentry-source-file="SupportArtists.tsx">
            Apply now
          </PartnerButton>
        </div>
      </div>
    </div>
  </section>;
export default SupportArtists;